<template>
  <div class="d-flex">
    <a
      style="width : 100% !important;"
      :href="`https://api.whatsapp.com/send?phone=${phone}&text=${text}`"
      target="_blank"
      :class="buttonClass + ' px-2'"
    >
      {{ buttonlabel }}
    </a>
  </div>
</template>
<script>
export default {
  props: ["phone", "text", "buttonlabel", "buttonClass"],
}
</script>
